var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#F14726"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 38,
    fill: "#F14726"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7833 41L41 49.7833V62.2167L49.7833 71H62.2167C65.1667 68.0667 71 62.2167 71 62.2167V49.7833L62.2167 41M51.1667 44.3333H60.8333L67.6667 51.1667V60.8333L60.8333 67.6667H51.1667L44.3333 60.8333V51.1667M54.3333 61H57.6667V64.3333H54.3333V61ZM54.3333 47.6667H57.6667V57.6667H54.3333V47.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1a46edab9c2498975fbf3ef5349d855c.svg";
export { ForwardRef as ReactComponent };